module.exports = __webpack_public_path__ + "static/media/telethon-kids-2023@2x.7e897fcc.png";